import React from "react";
import { useLang } from "@/lib/useLang";

export const StampOverlay = ({ visible }) => {
  const { t, lang } = useLang();
  if (!visible) return null;
  return (
    <div
      className="fixed inset-0 z-50 pointer-events-none flex items-center justify-center"
      data-testid="vote-stamp"
    >
      <div className="absolute inset-0 bg-white/70" />
      <div
        className="stamp absolute top-1/2 left-1/2"
        style={{
          transformOrigin: "center",
          color: "#E3000F",
          border: "8px solid #E3000F",
          padding: "1.5rem 3rem",
          fontFamily: lang === "ml"
            ? "'Baloo Chettan 2', 'Noto Sans Malayalam', sans-serif"
            : "'Anton', sans-serif",
          fontSize: lang === "ml" ? "3.5rem" : "5rem",
          letterSpacing: lang === "ml" ? "0.04em" : "0.15em",
          background: "transparent",
          boxShadow: "0 0 0 4px rgba(227, 0, 15, 0.15)",
          whiteSpace: "nowrap",
        }}
      >
        {t("voted_stamp")}
      </div>
    </div>
  );
};

export default StampOverlay;
